export default __webpack_public_path__ + "static/accents-mixing-colors-dont-light-af50f5d02855a02bf7e7a7944ff2d2d6.png";